// PrivacyPolicyComponent.js

import React from "react";
import { Nav } from "../../layouts/navbar/nav";
import images from "../../constant/images";
import { useTranslation } from "react-i18next";

const ConfidentialitePolitique = () => {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  return (
    <div
      className="flex flex-col gap-6 md:gap-12 min-h-screen"
      style={{
        backgroundImage: `url(${images.golf_field})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <Nav />
      <div className="flex justify-center px-4 md:mx-16">
        <div className="w-full md:w-[80%] lg:w-[60%] mx-auto px-4 sm:px-8 md:px-16 mb-10 md:mb-20 shadow-[5px_3px_15px_rgba(0,0,0,0.3)] py-6 md:py-12 border rounded-xl md:rounded-3xl bg-white">
          <h1 className="text-xl md:text-2xl font-bold mb-4">
            {t("PrivacyPolicy.title")}
          </h1>
          <p className="mb-4">{t("PrivacyPolicy.introduction")}</p>
          <h2 className="text-base md:text-lg font-semibold">
            {t("PrivacyPolicy.dataCollected")}
          </h2>
          <p>{t("PrivacyPolicy.dataContent")}</p>
          <ul className="list-disc pl-5 mb-4">
            {t("PrivacyPolicy.dataDetails", { returnObjects: true })?.map(
              (item, index) => (
                <li key={index}>{item}</li>
              )
            )}
          </ul>
          <h2 className="text-base md:text-lg font-semibold">
            {t("PrivacyPolicy.dataUsage")}
          </h2>
          <p>{t("PrivacyPolicy.usageContent")}</p>
          <ul className="list-disc pl-5 mb-4">
            {t("PrivacyPolicy.usageDetails", { returnObjects: true })?.map(
              (item, index) => (
                <li key={index}>{item}</li>
              )
            )}
          </ul>
          <h2 className="text-base md:text-lg font-semibold">
            {t("PrivacyPolicy.dataSharing")}
          </h2>
          <p>{t("PrivacyPolicy.visibilityContent.memberVisibility")}</p>
          <p>{t("PrivacyPolicy.visibilityContent.legalUsage")}</p>
          <h2 className="text-base md:text-lg font-semibold">
            {t("PrivacyPolicy.dataSecurity")}
          </h2>
          <p>{t("PrivacyPolicy.securityContent")}</p>
          <h2 className="text-base md:text-lg font-semibold">
            {t("PrivacyPolicy.yourRights")}
          </h2>
          <p>{t("PrivacyPolicy.rightsContent")}</p>
          <ul className="list-disc pl-5 mb-4">
            {t("PrivacyPolicy.rightsDetails", { returnObjects: true })?.map(
              (item, index) => (
                <li key={index}>{item}</li>
              )
            )}
          </ul>
          <h2 className="text-base md:text-lg font-semibold">
            {t("PrivacyPolicy.accountDeletionProcedure")}
          </h2>
          <p>{t("PrivacyPolicy.deletionContent")}</p>
          <h2 className="text-base md:text-lg font-semibold">
            {t("PrivacyPolicy.dataDeletion")}
          </h2>
          <p>{t("PrivacyPolicy.deletionDetails")}</p>
          <h2 className="text-base md:text-lg font-semibold">
            {t("PrivacyPolicy.policyChanges")}
          </h2>
          <p>{t("PrivacyPolicy.changesContent")}</p>
          <h2 className="text-base md:text-lg font-semibold">
            {t("PrivacyPolicy.contact")}
          </h2>
          <p>{t("PrivacyPolicy.contactContent")}</p>
          <p>{t("PrivacyPolicy.email")}</p>
        </div>
      </div>
    </div>
  );
};

export default ConfidentialitePolitique;
